const RESET = "JOBS/RESET";
const SET_PAGE = "JOBS/SET_PAGE";
const SET_ERROR = "JOBS/SET_ERROR";
const SET_IS_LOADING = "JOBS/SET_IS_LOADING";

const Types = {
  RESET,
  SET_PAGE,
  SET_ERROR,
  SET_IS_LOADING
};

export default Types;
